import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const ShowNote = (props) => {
  const [loading, setLoading] = useState(true);

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "9",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                {props.mode === "source" ? "Notatka - źródło" : "Notatka"}
                <br />
                <span style={{ fontSize: ".8vw" }}>
                  Kontakt: {props.lead.name}
                </span>
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>

            <div
              style={{
                display: "block",
                marginTop: "20px",
                width: "100%",
                fontSize: "1vw",
                textAlign: "left",
              }}
            >
              <>
                <p style={{ lineBreak: "anywhere" }}>
                  {props.mode === "note"
                    ? props.lead.statusNote
                    : props.mode === "source"
                    ? props.lead.sourceNote
                    : ""}
                </p>
              </>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ShowNote;
